import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-11-small', 'Number11Small', [["path",{"d":"M8 8h1v8"}],["path",{"d":"M14 8h1v8"}]]);